const BOOK_COUNTER_TEMPLATE = `
<%= collection.length %> <%= app.localeManager.get("book.result")%><% if (collection.length > 1) { %>s<% } %>
`;

const BookCounterComponent = Backbone.View.extend({

	id: "bookCounter",

	className: "",

	template: _.template(BOOK_COUNTER_TEMPLATE),

	render: function() {
		this.$el.html(this.template(this));

		return this;
	}
});
